<div>
   <app-position-in-virtual-config [id_parent_choose]="id_parent_choose" [array_object_selected]="array_object_selected" [selectedDevice]="selectedDevice"></app-position-in-virtual-config>
   <app-position-out-virtual-config [id_parent_choose]="id_parent_choose" [array_object_selected]="array_object_selected" [selectedDevice]="selectedDevice"></app-position-out-virtual-config>
</div>
